// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      businessPriority: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10"
      ]
    };
  }
};
